import { PROFILE_TYPES, USER_CODE_STATUS } from '@/utils/enums';
import Basic from '@/layouts/Basic';
import store from '@/store';

const router = [
    {
        path: '/qualification',
        component: Basic,
        meta: { auth: true },
        redirect: { name: 'qualification', params: { type: 'none' } },
        children: [
            {
                path: ':type',
                name: 'qualification',
                component: () => import('@/views/qualification'),
                meta: { auth: true },
                beforeEnter: (to) => {
                    if (!to.params.type) {
                        return { name: 'login' };
                    }

                    const allowsTypes = [PROFILE_TYPES.AFFILIATE, PROFILE_TYPES.SPECIALIST, PROFILE_TYPES.DEVELOPER];
                    if (!allowsTypes.includes(to.params.type)) {
                        return { name: 'home' };
                    }

                    // Verifica se o usuário já tem o perfil ativo, porém se o perfil for developer, verificar também se ele já completou a qualificação, caso não, prosseguir para a qualificação
                    const isDeveloperQualified = store.getters['profile/isDeveloperQualified'];
                    if (to.params.type === PROFILE_TYPES.DEVELOPER && !isDeveloperQualified) {
                        return true;
                    }

                    // Se o perfil não for developer, ou se for developer e já tiver completado a qualificação, verificar se o perfil está ativo
                    const roleStatus = store.getters['profile/userRolesStatus'].find((s) => s.profile === to.params.type);
                    if (roleStatus.value === USER_CODE_STATUS.ACTIVE) {
                        return { name: 'home' };
                    }
                },
            },
        ],
    },
];

export default router;
